<template>
  <v-container fluid class="mt-4 ml-2">
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="text-subtitle-1 flex-wrap">
            Análisis Meta Inscritos
            <v-spacer></v-spacer>
            <v-btn
              outlined
              small
              tile
              class="mr-2 mb-1"
              @click="dialogPrompt = true"
            >
              <v-icon left small>mdi-text-box-edit-outline</v-icon>
              Prompt
            </v-btn>
            <v-btn
              outlined
              small
              tile
              class="mr-2 mb-1"
              @click="dialogCampania = true"
            >
              <v-icon left small>mdi-bullhorn-outline</v-icon>
              Campaña
            </v-btn>
            <v-btn
              outlined
              small
              tile
              class="mr-2 mb-1"
              @click="abrirLogo()"
            >
              <v-icon left small>mdi-image-frame</v-icon>
              Logo
            </v-btn>
            <v-btn
              color="deep-purple darken-1"
              dark
              small
              tile
              class="mr-2 mb-1"
              :loading="generando"
              :disabled="!alumnos.length"
              @click="generarImagenes()"
            >
              <v-icon left small>mdi-image-auto-adjust</v-icon>
              Generar póster
            </v-btn>
            <v-btn
              outlined
              small
              tile
              class="mr-2 mb-1"
              :loading="cargandoGuardadas"
              :disabled="!ciclo"
              @click="verGuardadas()"
            >
              <v-icon left small>mdi-folder-image</v-icon>
              Ver guardadas
            </v-btn>
            <v-btn
              color="primary"
              dark
              small
              tile
              class="mb-1"
              :loading="cargar"
              @click="consultar()"
            >
              <v-icon left small>mdi-magnify</v-icon>
              Consultar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="escuela"
                  :items="opcionesEscuela"
                  label="Escuela"
                  filled
                  dense
                  hide-details
                  item-text="text"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  v-model="ciclo"
                  :items="ciclosFiltrados"
                  label="Ciclo"
                  filled
                  dense
                  hide-details
                  return-object
                  clearable
                  :loading="cargandoCiclos"
                  item-text="cicloLabel"
                  item-value="id_ciclo"
                  prepend-inner-icon="mdi-calendar-range"
                  no-data-text="No hay ciclos"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="plantel"
                  :items="plantelesFiltrados"
                  label="Plantel (opcional)"
                  filled
                  dense
                  hide-details
                  clearable
                  item-text="plantel"
                  item-value="id_plantel"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <div class="text-caption grey--text mt-2">
              Segmento ≥{{ minSegmento }} alumnos → OpenAI nicho → Leonardo foto → póster PNG
              <span v-if="promptMeta && promptMeta.actualizado_en">
                · prompt: {{ formatFechaHora(promptMeta.actualizado_en) }}
              </span>
              <span v-else-if="!prompt" class="orange--text"> · falta prompt</span>
              <span v-if="!logoUrl" class="orange--text"> · falta logo {{ escuela === 2 ? 'FAST' : 'INBI' }}</span>
              <span v-if="openaiConfigurado === false" class="error--text"> · falta OPENAI_API_KEY</span>
              <span v-if="leonardoConfigurado === false" class="error--text"> · falta LEONARDO_API_KEY</span>
            </div>

            <v-row v-if="meta" dense class="mt-3">
              <v-col cols="12" sm="4" md="3">
                <v-sheet rounded class="pa-3 ami-stat ami-stat--primary">
                  <div class="text-caption">Alumnos NI</div>
                  <div class="text-h5 font-weight-bold">{{ meta.total }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-sheet rounded class="pa-3 ami-stat ami-stat--ok">
                  <div class="text-caption">Con datos LMS</div>
                  <div class="text-h5 font-weight-bold">{{ meta.con_datos_lms }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-sheet rounded class="pa-3 ami-stat ami-stat--warn">
                  <div class="text-caption">Sin datos LMS</div>
                  <div class="text-h5 font-weight-bold">{{ meta.sin_datos_lms }}</div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row justify="end" class="mt-2">
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="search"
                  label="Buscar alumno, matrícula, plantel, grupo..."
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="alumnos"
              :search="search"
              item-key="id_alumno"
              class="elevation-0 mt-2"
              dense
              :loading="cargar"
              :items-per-page="25"
              :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
            >
              <template v-slot:item.tiene_datos_lms="{ item }">
                <v-chip
                  x-small
                  dark
                  :color="item.tiene_datos_lms ? 'teal darken-1' : 'grey'"
                >
                  {{ item.tiene_datos_lms ? 'Sí' : 'No' }}
                </v-chip>
              </template>

              <template v-slot:item.sexo_texto="{ item }">
                <span v-if="item.sexo_texto && item.sexo_texto !== '—'">{{ item.sexo_texto }}</span>
                <span v-else class="grey--text">—</span>
              </template>

              <template v-slot:item.fecha_pago="{ item }">
                <span class="text-caption">{{ formatFecha(item.fecha_pago) }}</span>
              </template>

              <template v-slot:item.email="{ item }">
                <span class="text-caption">{{ item.email || '—' }}</span>
              </template>

              <template v-slot:item.telefono_lms="{ item }">
                <span class="text-caption">{{ item.telefono_lms || '—' }}</span>
              </template>

              <template v-slot:item.ocupacion_texto="{ item }">
                <span>{{ textoOGuion(item.ocupacion_texto) }}</span>
              </template>

              <template v-slot:item.estado_civil_texto="{ item }">
                <span>{{ textoOGuion(item.estado_civil_texto) }}</span>
              </template>

              <template v-slot:item.medio_contacto_texto="{ item }">
                <span>{{ textoOGuion(item.medio_contacto_texto) }}</span>
              </template>

              <template v-slot:item.motivo_estudio_texto="{ item }">
                <span>{{ textoOGuion(item.motivo_estudio_texto) }}</span>
              </template>

              <template v-slot:item.transporte_texto="{ item }">
                <span>{{ textoOGuion(item.transporte_texto) }}</span>
              </template>

              <template v-slot:item.estado_texto="{ item }">
                <span>{{ textoOGuion(item.estado_texto) }}</span>
              </template>

              <template v-slot:item.hijos="{ item }">
                <span>{{ item.hijos != null && item.hijos !== '' ? item.hijos : '—' }}</span>
              </template>

              <template v-slot:item.colonia="{ item }">
                <span class="text-caption">{{ item.colonia || '—' }}</span>
              </template>

              <template v-slot:item.municipio="{ item }">
                <span class="text-caption">{{ item.municipio || '—' }}</span>
              </template>

              <template v-slot:item.facebook="{ item }">
                <span class="text-caption">{{ item.facebook || '—' }}</span>
              </template>

              <template v-slot:item.rango_edad="{ item }">
                <v-chip
                  v-if="item.rango_edad && item.rango_edad !== 'Fuera de rango'"
                  x-small
                  outlined
                  color="primary"
                >
                  {{ item.rango_edad }}
                </v-chip>
                <span v-else class="grey--text">—</span>
              </template>

              <template v-slot:no-data>
                <div class="py-4 grey--text text-center">
                  Selecciona escuela y ciclo, luego pulsa Consultar.
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal campaña -->
    <v-dialog v-model="dialogCampania" max-width="520px">
      <v-card>
        <v-card-title class="text-subtitle-1">
          Textos de campaña
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogCampania = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="campania.titulo" label="Título" filled dense hide-details class="mb-3"></v-text-field>
          <v-text-field v-model="campania.oferta" label="Oferta / badge" filled dense hide-details class="mb-3"></v-text-field>
          <v-text-field v-model="campania.fecha_texto" label="Fecha / texto secundario" filled dense hide-details></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogCampania = false">Cerrar</v-btn>
          <v-btn color="teal darken-1" dark small tile :loading="guardandoCampania" @click="guardarCampania()">
            Guardar campaña
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal logo -->
    <v-dialog v-model="dialogLogo" max-width="480px">
      <v-card>
        <v-card-title class="text-subtitle-1">
          Logo {{ escuela === 2 ? 'FAST' : 'INBI' }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogLogo = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-img v-if="logoUrl" :src="logoUrl" max-height="120" contain class="mb-3 grey lighten-4"></v-img>
          <v-file-input
            v-model="logoFile"
            label="Subir logo (PNG/JPG)"
            filled
            dense
            accept="image/*"
            prepend-icon="mdi-camera"
            show-size
            hide-details
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogLogo = false">Cerrar</v-btn>
          <v-btn color="teal darken-1" dark small tile :loading="subiendoLogo" :disabled="!logoFile" @click="subirLogo()">
            Guardar logo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal prompt de diseño -->
    <v-dialog v-model="dialogPrompt" max-width="720px" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1">
          Prompt de diseño (Leonardo)
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogPrompt = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="prompt"
            label="Prompt de diseño"
            filled
            dense
            rows="12"
            auto-grow
            hide-details="auto"
            placeholder="Ej: Foto publicitaria realista, iluminación natural, estilo campaña escolar moderna, sin texto en la imagen..."
          ></v-textarea>
          <div
            v-if="promptMeta && promptMeta.actualizado_en"
            class="text-caption grey--text mt-2"
          >
            Último guardado: {{ formatFechaHora(promptMeta.actualizado_en) }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogPrompt = false">Cerrar</v-btn>
          <v-btn
            color="teal darken-1"
            dark
            small
            tile
            :loading="guardandoPrompt"
            @click="guardarPromptDesdeModal()"
          >
            <v-icon left small>mdi-content-save</v-icon>
            Guardar prompt
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Resultados generación / guardadas -->
    <v-dialog v-model="dialogImagenes" max-width="1100px" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1 flex-wrap">
          {{ modoDialogo === 'guardadas' ? 'Pósters guardados' : 'Póster generado' }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogImagenes = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert v-if="metaGeneracion && modoDialogo === 'generadas'" dense text type="info" class="mb-3">
            {{ metaGeneracion.total_alumnos }} alumnos · segmento ≥{{ metaGeneracion.min_segmento || minSegmento }} · póster compuesto
          </v-alert>
          <v-alert v-if="segmentoActual && modoDialogo === 'generadas'" dense text type="success" class="mb-3">
            Segmento: {{ segmentoActual.rango_edad }} · {{ segmentoActual.sexo }} ·
            {{ segmentoActual.ocupacion }} · {{ segmentoActual.motivo_estudio }}
            ({{ segmentoActual.total }} alumnos)
          </v-alert>

          <v-row dense>
            <v-col
              v-for="(item, idx) in itemsDialogo"
              :key="itemKey(item, idx)"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card outlined class="ami-img-card">
                <v-card-subtitle class="pb-0">
                  <strong>{{ tituloNicho(item) }}</strong>
                </v-card-subtitle>
                <v-card-text class="pt-1 text-caption grey--text text--darken-1">
                  {{ caracteristicasNicho(item) || '—' }}
                </v-card-text>

                <template v-if="urlImagen(item)">
                  <v-img
                    :src="urlImagen(item)"
                    aspect-ratio="0.8"
                    contain
                    class="ami-img"
                    style="cursor: pointer;"
                    @click="abrirVista(item)"
                  ></v-img>
                  <v-card-actions class="flex-wrap">
                    <v-btn x-small text color="primary" @click="abrirVista(item)">
                      <v-icon left x-small>mdi-eye</v-icon>
                      Ver
                    </v-btn>
                    <v-btn x-small text color="green darken-2" @click="descargarImagen(item)">
                      <v-icon left x-small>mdi-download</v-icon>
                      Descargar
                    </v-btn>
                    <v-chip v-if="item.guardado || item.id" x-small color="teal" dark class="ml-1">
                      Guardado
                    </v-chip>
                  </v-card-actions>
                </template>
                <v-alert v-else dense text type="error" class="ma-2">
                  {{ item.message || 'No se generó imagen' }}
                </v-alert>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogImagenes = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Vista ampliada -->
    <v-dialog v-model="dialogVista" max-width="800px">
      <v-card v-if="vistaActual">
        <v-card-title class="text-subtitle-1">
          {{ tituloNicho(vistaActual) }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogVista = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p class="text-caption mb-2">{{ caracteristicasNicho(vistaActual) }}</p>
          <v-img
            :src="urlImagen(vistaActual)"
            contain
            max-height="560"
            class="ami-img"
          ></v-img>
        </v-card-text>
        <v-card-actions>
          <v-btn color="green darken-2" dark small tile @click="descargarImagen(vistaActual)">
            <v-icon left small>mdi-download</v-icon>
            Descargar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogVista = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="generando" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

export default {
  name: 'AnalisisMetaInscritos',

  components: { Alerta, carga },

  mixins: [validarErrores],

  data: () => ({
    parametros: {
      dialogError: false,
      mensaje: '',
      color: '',
    },
    respuestaAlerta: false,
    cargar: false,
    cargandoCiclos: false,
    guardandoPrompt: false,
    guardandoCampania: false,
    subiendoLogo: false,
    generando: false,
    cargandoGuardadas: false,
    dialogPrompt: false,
    dialogCampania: false,
    dialogLogo: false,

    escuela: 1,
    ciclo: null,
    plantel: null,
    search: '',
    prompt: '',
    promptMeta: null,
    campania: { titulo: '', oferta: '', fecha_texto: '' },
    logoUrl: null,
    logoFile: null,
    leonardoConfigurado: null,
    openaiConfigurado: null,
    nichosFijos: 1,
    minSegmento: 15,

    ciclos: [],
    planteles: [],
    alumnos: [],
    meta: null,

    dialogImagenes: false,
    dialogVista: false,
    modoDialogo: 'generadas',
    resultadosImagenes: [],
    imagenesGuardadas: [],
    metaGeneracion: null,
    segmentoActual: null,
    loteId: null,
    vistaActual: null,

    opcionesEscuela: [
      { text: 'INBI', value: 1 },
      { text: 'FAST', value: 2 },
    ],

    headers: [
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Alumno', value: 'alumno' },
      { text: 'Plantel', value: 'plantel' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Vendedora', value: 'vendedora' },
      { text: 'Fecha pago', value: 'fecha_pago' },
      { text: 'LMS', value: 'tiene_datos_lms', align: 'center' },
      { text: 'Edad', value: 'edad' },
      { text: 'Rango edad', value: 'rango_edad' },
      { text: 'Sexo', value: 'sexo_texto' },
      { text: 'Email', value: 'email' },
      { text: 'Teléfono', value: 'telefono_lms' },
      { text: 'Ocupación', value: 'ocupacion_texto' },
      { text: 'Estado civil', value: 'estado_civil_texto' },
      { text: 'Hijos', value: 'hijos' },
      { text: 'Medio contacto', value: 'medio_contacto_texto' },
      { text: 'Motivo estudio', value: 'motivo_estudio_texto' },
      { text: 'Transporte', value: 'transporte_texto' },
      { text: 'Colonia', value: 'colonia' },
      { text: 'Municipio', value: 'municipio' },
      { text: 'Estado', value: 'estado_texto' },
      { text: 'Facebook', value: 'facebook' },
    ],
  }),

  computed: {
    ciclosFiltrados () {
      return this.ciclos || []
    },

    plantelesFiltrados () {
      return this.planteles || []
    },

    resultadosOk () {
      return (this.resultadosImagenes || []).filter((r) => r.ok && this.urlImagen(r))
    },

    itemsDialogo () {
      return this.modoDialogo === 'guardadas'
        ? this.imagenesGuardadas
        : this.resultadosImagenes
    },
  },

  watch: {
    async escuela () {
      this.ciclo = null
      this.plantel = null
      this.alumnos = []
      this.meta = null
      this.logoUrl = null
      this.logoFile = null
      await Promise.all([this.cargarCiclos(), this.cargarPlanteles(), this.cargarPrompt()])
    },
  },

  async created () {
    await Promise.all([
      this.cargarCiclos(),
      this.cargarPlanteles(),
      this.cargarPrompt(),
    ])
  },

  methods: {
    textoOGuion (valor) {
      if (valor == null || valor === '' || valor === '—') return '—'
      return valor
    },

    formatFecha (valor) {
      if (!valor) return '—'
      const s = String(valor).slice(0, 10)
      const [y, m, d] = s.split('-')
      if (!y || !m || !d) return s
      return `${d}/${m}/${y}`
    },

    formatFechaHora (valor) {
      if (!valor) return '—'
      const s = String(valor)
      const [fecha, hora] = s.split(/[T ]/)
      return hora ? `${this.formatFecha(fecha)} ${hora.slice(0, 5)}` : this.formatFecha(fecha)
    },

    cicloLabel (ciclo) {
      if (!ciclo) return ''
      const total = Number(ciclo.total_inscritos)
      if (Number.isFinite(total) && total >= 0) {
        return `${ciclo.ciclo} (${total} NI)`
      }
      return ciclo.ciclo || ''
    },

    elegirCicloPorDefecto (lista) {
      const items = lista || []
      if (!items.length) return null
      const conInscritos = items.find((c) => Number(c.total_inscritos) > 0)
      return conInscritos || items[0]
    },

    esPlantelFast (plantel) {
      if (plantel && plantel.escuela != null) return Number(plantel.escuela) === 2
      return String((plantel && plantel.plantel) || '').toUpperCase().includes('FAST')
    },

    mensajeErrorHttp (error, fallback) {
      const status = error.response && error.response.status
      const msg = error.response && error.response.data && error.response.data.message
      if (status && msg) return `[${status}] ${msg}`
      if (msg) return msg
      if (error.message === 'Network Error') {
        return 'No hay conexión con api-rh. Verifica que el API esté activo.'
      }
      return fallback
    },

    urlImagen (item) {
      if (!item) return null
      if (item.poster_url) return item.poster_url
      if (item.image_url) return item.image_url
      if (item.images && item.images[0] && item.images[0].url) return item.images[0].url
      return null
    },

    abrirLogo () {
      this.logoFile = null
      this.dialogLogo = true
    },

    tituloNicho (item) {
      if (!item) return 'Nicho'
      const n = item.nicho || {}
      const num = n.numero || item.nicho_numero
      const nombre = n.nombre || item.nicho_nombre || 'Sin nombre'
      return num ? `${num}. ${nombre}` : nombre
    },

    caracteristicasNicho (item) {
      if (!item) return ''
      const n = item.nicho || {}
      return n.caracteristicas || item.nicho_caracteristicas || ''
    },

    itemKey (item, idx) {
      return item.id || item.generation_id || item.id_guardado || `n-${idx}`
    },

    nombreArchivo (item) {
      const nombre = (this.tituloNicho(item) || 'nicho')
        .toLowerCase()
        .replace(/[^\w\-]+/g, '_')
        .slice(0, 60)
      return `${nombre || 'poster'}.png`
    },

    abrirVista (item) {
      this.vistaActual = item
      this.dialogVista = true
    },

    async descargarImagen (item) {
      const url = this.urlImagen(item)
      if (!url) return
      try {
        const response = await this.$http.get('kpi.analisis.meta.inscritos.imagen.proxy', {
          params: {
            url,
            download: 1,
            filename: this.nombreArchivo(item),
          },
          responseType: 'blob',
        })
        const blob = response.data instanceof Blob
          ? response.data
          : new Blob([response.data], { type: 'image/jpeg' })
        const href = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = href
        a.download = this.nombreArchivo(item)
        a.click()
        URL.revokeObjectURL(href)
      } catch (error) {
        // fallback: abrir en pestaña
        window.open(url, '_blank')
      }
    },

    payloadFiltros () {
      if (!this.ciclo) {
        this.validarError('Selecciona un ciclo')
        return null
      }
      return {
        escuela: this.escuela,
        id_ciclo: this.ciclo.id_ciclo,
        id_ciclo_relacionado: this.ciclo.id_ciclo_relacionado || this.ciclo.id_ciclo,
        idplantel: this.plantel != null && this.plantel !== '' ? Number(this.plantel) : null,
      }
    },

    async cargarPrompt () {
      try {
        const response = await this.$http.get('kpi.analisis.meta.inscritos.prompt', {
          params: { escuela: this.escuela },
        })
        this.prompt = (response.data && response.data.prompt) || ''
        this.promptMeta = (response.data && response.data.meta) || null
        this.campania = Object.assign(
          { titulo: '', oferta: '', fecha_texto: '' },
          (response.data && response.data.campania) || {}
        )
        this.logoUrl = response.data && response.data.logo && response.data.logo.url
          ? response.data.logo.url
          : null
        this.leonardoConfigurado = !!(response.data && response.data.leonardo_configurado)
        this.openaiConfigurado = !!(response.data && response.data.openai_configurado)
        if (response.data && response.data.nichos_fijos) {
          this.nichosFijos = Number(response.data.nichos_fijos) || 1
        }
        if (response.data && response.data.min_segmento) {
          this.minSegmento = Number(response.data.min_segmento) || 15
        }
      } catch (error) {
        this.prompt = this.prompt || ''
      }
    },

    async guardarCampania () {
      this.guardandoCampania = true
      try {
        await this.$http.post('kpi.analisis.meta.inscritos.campania', this.campania)
        this.validarSuccess('Campaña guardada')
        this.dialogCampania = false
      } catch (error) {
        this.validarError(this.mensajeErrorHttp(error, 'Error al guardar campaña'))
      } finally {
        this.guardandoCampania = false
      }
    },

    async subirLogo () {
      if (!this.logoFile) {
        this.validarError('Selecciona un archivo')
        return
      }
      this.subiendoLogo = true
      try {
        const form = new FormData()
        form.append('logo', this.logoFile)
        form.append('escuela', String(this.escuela))
        const response = await this.$http.post('kpi.analisis.meta.inscritos.logo', form, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        this.logoUrl = response.data && response.data.logo && response.data.logo.url
        this.validarSuccess('Logo guardado')
        this.dialogLogo = false
        this.logoFile = null
      } catch (error) {
        this.validarError(this.mensajeErrorHttp(error, 'Error al subir logo'))
      } finally {
        this.subiendoLogo = false
      }
    },

    async guardarPrompt () {
      const texto = String(this.prompt || '').trim()
      if (!texto) {
        this.validarError('Escribe un prompt antes de guardar')
        return false
      }

      this.guardandoPrompt = true
      try {
        const response = await this.$http.post('kpi.analisis.meta.inscritos.prompt', {
          prompt: texto,
          nombre: 'analisis_meta_inscritos',
        })
        this.validarSuccess((response.data && response.data.message) || 'Prompt guardado')
        await this.cargarPrompt()
        return true
      } catch (error) {
        this.validarError(this.mensajeErrorHttp(error, 'Error al guardar prompt'))
        return false
      } finally {
        this.guardandoPrompt = false
      }
    },

    async guardarPromptDesdeModal () {
      const ok = await this.guardarPrompt()
      if (ok) this.dialogPrompt = false
    },

    async generarImagenes () {
      if (!this.alumnos.length) {
        this.validarError('Consulta alumnos primero')
        return
      }
      if (!String(this.prompt || '').trim()) {
        this.validarError('Configura el prompt de diseño antes de generar')
        this.dialogPrompt = true
        return
      }
      if (!this.logoUrl) {
        this.validarError(`Sube el logo de ${this.escuela === 2 ? 'FAST' : 'INBI'} antes de generar`)
        this.dialogLogo = true
        return
      }

      this.generando = true
      this.resultadosImagenes = []
      this.metaGeneracion = null
      this.segmentoActual = null
      this.loteId = null

      try {
        const response = await this.$http.post('kpi.analisis.meta.inscritos.generar', {
          prompt: this.prompt,
          escuela: this.escuela,
          id_ciclo: this.ciclo ? this.ciclo.id_ciclo : null,
          alumnos: this.alumnos,
          campania: this.campania,
        })
        this.resultadosImagenes = (response.data && response.data.resultados) || []
        this.metaGeneracion = (response.data && response.data.meta) || null
        this.segmentoActual = (response.data && response.data.segmento) || null
        this.loteId = (response.data && response.data.lote_id) || null
        this.modoDialogo = 'generadas'
        this.dialogImagenes = true
        const ok = this.metaGeneracion ? this.metaGeneracion.ok : 0
        if (ok > 0) {
          this.validarSuccess((response.data && response.data.message) || 'Póster generado')
        } else {
          this.validarError((response.data && response.data.message) || 'No se generó el póster')
        }
      } catch (error) {
        this.validarError(this.mensajeErrorHttp(error, 'Error al generar póster'))
      } finally {
        this.generando = false
      }
    },

    async verGuardadas () {
      if (!this.ciclo) {
        this.validarError('Selecciona un ciclo')
        return
      }
      this.cargandoGuardadas = true
      try {
        const response = await this.$http.get('kpi.analisis.meta.inscritos.imagenes', {
          params: {
            escuela: this.escuela,
            id_ciclo: this.ciclo.id_ciclo,
            limit: 50,
          },
        })
        this.imagenesGuardadas = (response.data && response.data.imagenes) || []
        this.modoDialogo = 'guardadas'
        this.dialogImagenes = true
        if (!this.imagenesGuardadas.length) {
          this.validarError('No hay pósters guardados para este ciclo')
        }
      } catch (error) {
        this.validarError(this.mensajeErrorHttp(error, 'Error al cargar pósters'))
      } finally {
        this.cargandoGuardadas = false
      }
    },

    async cargarCiclos () {
      this.cargandoCiclos = true
      try {
        const response = await this.$http.get('panel.inscritos.ciclo.ciclos', {
          params: { escuela: this.escuela },
        })
        this.ciclos = (response.data || []).map((c) => ({
          ...c,
          cicloLabel: this.cicloLabel(c),
        }))
        if (!this.ciclo && this.ciclos.length) {
          this.ciclo = this.elegirCicloPorDefecto(this.ciclos)
        }
      } catch (error) {
        this.ciclos = []
        this.validarError(this.mensajeErrorHttp(error, 'No se pudieron cargar los ciclos'))
      } finally {
        this.cargandoCiclos = false
      }
    },

    async cargarPlanteles () {
      try {
        const response = await this.$http.get('planteles.activos')
        const esFast = Number(this.escuela) === 2
        this.planteles = (response.data || [])
          .filter((p) => (esFast ? this.esPlantelFast(p) : !this.esPlantelFast(p)))
          .sort((a, b) => String(a.plantel || '').localeCompare(String(b.plantel || '')))
      } catch (error) {
        this.planteles = []
        this.validarError(
          (error.response && error.response.data && error.response.data.message)
            || 'No se pudieron cargar planteles'
        )
      }
    },

    async consultar () {
      const payload = this.payloadFiltros()
      if (!payload) return

      this.cargar = true
      this.alumnos = []
      this.meta = null

      try {
        const response = await this.$http.post('kpi.analisis.meta.inscritos', payload)
        this.alumnos = response.data.alumnos || []
        this.meta = response.data.meta || null
      } catch (error) {
        this.validarError(
          this.mensajeErrorHttp(error, 'Error al consultar análisis meta inscritos')
        )
        this.alumnos = []
        this.meta = null
      } finally {
        this.cargar = false
      }
    },
  },
}
</script>

<style scoped>
.ami-stat {
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.ami-stat--primary {
  background: #e3f2fd;
  color: #0d47a1;
}
.ami-stat--ok {
  background: #e0f2f1;
  color: #004d40;
}
.ami-stat--warn {
  background: #fff8e1;
  color: #e65100;
}
.ami-img-card {
  min-height: 180px;
}
.ami-img {
  background: #f5f5f5;
}
</style>
